// Bourse Numérique de l'Huile — référence INDICATIVE.
// Aucune écriture financière : cette référence ne touche ni le CMP, ni les achats,
// ni les stocks, ni les factures, ni la comptabilité, ni les prix déjà saisis.
const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api/bourse`;

// Le secret d'administration n'est jamais dans le code : il est saisi par
// l'administrateur et conservé uniquement pour la session du navigateur.
const CLE_SESSION = 'bourse.jeton_admin';
export const lireJetonAdmin = () => sessionStorage.getItem(CLE_SESSION) || '';
export const ecrireJetonAdmin = (v) => (v ? sessionStorage.setItem(CLE_SESSION, v) : sessionStorage.removeItem(CLE_SESSION));

const entetes = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${lireJetonAdmin()}` });

const requete = async (...args) => {
  try { return await fetch(...args); }
  catch { return { ok: false, status: 0, json: async () => ({ detail: 'Connexion au serveur impossible. Réessayez le chargement.' }) }; }
};

const json = async (r) => {
  const data = await r.json().catch(() => null);
  if (!r.ok) return { error: data?.detail ?? `Erreur ${r.status}`, data: null };
  return { error: null, data };
};

export const fetchReferenceBourse = async () => (await json(await requete(`${API}/reference`))).data;
export const fetchEtatBourse = async () => json(await requete(`${API}/etat`, { headers: entetes() }));
export const fetchPartenairesBourse = async () => json(await requete(`${API}/partenaires`, { headers: entetes() }));
export const fetchCotationsBourse = async () => json(await requete(`${API}/cotations`, { headers: entetes() }));
export const fetchMessagesBourse = async () => json(await requete(`${API}/messages`, { headers: entetes() }));

export const ajouterPartenaireBourse = async (payload) =>
  json(await requete(`${API}/partenaires`, { method: 'POST', headers: entetes(), body: JSON.stringify(payload) }));

export const modifierPartenaireBourse = async (id, payload) =>
  json(await requete(`${API}/partenaires/${id}`, { method: 'PATCH', headers: entetes(), body: JSON.stringify(payload) }));

export const diffuserDemandeBourse = async () =>
  json(
    await requete(`${API}/diffusion`, {
      method: 'POST',
      headers: entetes(),
      body: JSON.stringify({ request_id: `dem-${new Date().toISOString().slice(0, 13).replace(/[-T:]/g, '')}` }),
    })
  );
